module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-2.2ac4c099.svg";